import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import firebaseConfig from "./config.json";
import FingerprintJS from "@sparkstone/fingerprintjs";
import { useFCMStore } from "./fcmStore";

// https://nuxt.com/docs/api/configuration/nuxt-config
const app = initializeApp(firebaseConfig.config);
const messaging = getMessaging(app);
import { useCookie } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  const store = useFCMStore();
  // if (process.client) {
  //   //- Load service worker
  //   // if ("serviceWorker" in navigator) {
  //   //   navigator.serviceWorker
  //   //     .register("/firebase-messaging-sw.js")
  //   //     .then(function (registration) {
  //   //       // console.log("Registration successful, scope is:", registration.scope);
  //   //     })
  //   //     .catch(function (err) {
  //   //       console.log("Service worker registration failed, error:", err);
  //   //     });
  //   // }
  //   // document.addEventListener('DOMContentLoaded', () => {
  //   // })
  // }
  async function setFingerprint() {
    const fingerprnt = useCookie("_fgrprnt", {
      sameSite: "lax",
      maxAge: 61536000,
    });

    if (fingerprnt?.value === undefined) {
      const fp = await FingerprintJS.load();
      const fpx = await fp.get();
      store.fingerprint = fpx.visitorId;
      fingerprnt.value = fpx.visitorId;
    } else {
      store.fingerprint = fingerprnt.value;
    }
  }

  const requestPermission = () => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log("Notification permission granted.");

        getToken(messaging, {
          vapidKey: firebaseConfig.vapidKey,
        })
          .then(async (currentToken) => {
            if (currentToken) {
              store.fcmToken = currentToken;

              await setFingerprint();

              // save to db
              store.save();
            } else {
              console.log(
                "No registration token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
          });
      } else {
        console.log("Unable to get permission to notify.");
      }
    });
  };
  return {
    provide: {
      fcm: {
        messaging,
        store,
        requestPermission,
      },
    },
  };
});
